import {css, styled} from '@vebox/etui-system';
import {Div, DivProps} from '@vebox/etui-system-elements';
import {Theme} from "@vebox/etui-themes";

interface ASHeaderDivProps extends DivProps {
    isOpen?: boolean;
}

export const AccordionSectionHeaderDiv = styled(Div).attrs(
    ({theme}: ASHeaderDivProps): ASHeaderDivProps => ({
        tabIndex: 0,
        fontSize: (theme as Theme).typography.fontSizeLarge,
    }),
)`
    cursor: pointer;
    user-select: none;
    width: 100%;
    transition: 0.2s;

    ${({theme}: ASHeaderDivProps) => {
        return css`
            &:focus-visible,
            &:hover {
                outline: 0;
                background-color: ${(theme as Theme).palette.action.hover};
            }
        `;
    }};

    ${({theme, isOpen}: ASHeaderDivProps) => {
        if (isOpen) {
            return css`
                background-color: ${(theme as Theme).palette.action.hover};
            `;
        }
        return ``;
    }};
`;
